import { onMounted, ref } from "vue";

export default function useEnterAnimation(delay = 0, animation = 'fade-slide') {
  const isVisible = ref(false);

  onMounted(() => {
    setTimeout(() => {
      isVisible.value = true;
    }, delay);
  });

  return {
    isVisible,
    animationClass: animation,
  };
}
